import { HiOutlineLockClosed, HiOutlineMail } from "react-icons/hi";
import {
  HiOutlineClipboardDocumentList,
  HiOutlineCog8Tooth,
  HiOutlineSquares2X2,
  HiOutlineTableCells,
} from "react-icons/hi2";
import {
  LuFileChartColumnIncreasing,
  LuMessageCircleQuestion,
  LuPackageSearch,
} from "react-icons/lu";
import { PiSwap } from "react-icons/pi";
import { RiExchangeBoxLine } from "react-icons/ri";
import {
  TbTransfer,
  TbTransferIn,
  TbTransferOut,
  TbTruck,
  TbTruckReturn,
} from "react-icons/tb";
import { useSelector } from "react-redux";

const routesConfigAdmin = [
  {
    id: "dashboards",
    title: "Overview",
    messageId: "sidebar.application",
    type: "group",
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        messageId: "menu.dashboard",
        icon: <HiOutlineSquares2X2 size={18} strokeWidth={1.75} />,
        path: "/dashboard",
      },
      {
        id: "transactions",
        title: "Transactions",
        messageId: "menu.tickets",
        icon: <RiExchangeBoxLine />,
        type: "collapse",
        children: [
          {
            id: "allot-order",
            title: "Allot Order",
            messageId: "menu.po",
            icon: <TbTruck />,
            path: "/allot-order",
          },
          {
            id: "allot-order-nonKit",
            title: "Trading Sales Order",
            messageId: "menu.po",
            icon: <TbTruck />,
            path: "/allot-order-nonKit",
          },
          {
            id: "return-order",
            title: "Return Order",
            messageId: "menu.ro",
            icon: <TbTruckReturn />,
            path: "/return-order",
          },
          {
            id: "damage-swap",
            title: "Damage Swap",
            messageId: "menu.ds",
            icon: <PiSwap />,
            path: "/damage-swap",
          },
          {
            id: "transfer-in",
            title: "Transfer In",
            messageId: "menu.ti",
            icon: <TbTransferIn />,
            path: "/transfer-in",
          },
          {
            id: "transfer-out",
            title: "Transfer Out",
            messageId: "menu.to",
            icon: <TbTransferOut />,
            path: "/transfer-out",
          },
          {
            id: "bulk-transfer-in",
            title: "Bulk Transfer IN",
            messageId: "menu.bulk-transfers-in",
            icon: <TbTransfer />,
            path: "/bulk-transfer-in",
          },
          {
            id: "bulk-transfer-out",
            title: "Bulk Transfer Out",
            messageId: "menu.bulk-transfers-out",
            icon: <TbTransfer />,
            path: "/bulk-transfer-out",
          },
        ],
      },
      {
        id: "layouts",
        title: "Layouts",
        messageId: "menu.layouts",
        icon: <HiOutlineTableCells size={18} strokeWidth={1.75} />,
        path: "/layouts",
      },
      {
        id: "reports",
        title: "Reports",
        messageId: "menu.reports",
        icon: <LuFileChartColumnIncreasing />,
        path: "/reports",
      },
      {
        id: "settings",
        title: "Settings",
        messageId: "menu.settings",
        icon: <HiOutlineCog8Tooth size={18} strokeWidth={1.75} />,
        type: "collapse",
        children: [
          {
            id: "changepassword",
            title: "Change Password",
            messageId: "menu.cp",
            icon: <HiOutlineLockClosed />,
            path: "/changepassword",
          },
          {
            id: "subscription",
            title: "Reports Subscription",
            messageId: "menu.sub",
            icon: <HiOutlineMail />,
            path: "/subscription",
          },
        ],
      },
      {
        id: "jobs-tracker",
        title: "Jobs Tracker",
        messageId: "menu.jobs",
        icon: <HiOutlineClipboardDocumentList size={18} strokeWidth={1.75} />,
        path: "/jobs-tracker",
      },
      {
        id: "track-order",
        title: "Track Order",
        messageId: "menu.track",
        icon: <LuPackageSearch />,
        path: "/track-order",
      },
      {
        id: "Help&Support",
        title: "Help & Support",
        messageId: "menu.track",
        icon: <LuMessageCircleQuestion />,
        path: "/Help&Support",
      },
    ],
  },
];

export function useRoutesConfigAdmin() {
  const { currentCompany } = useSelector((state) => state.companies);
  const contractType = currentCompany?.contractType || null;
  const bpCode = currentCompany?.bpCode || localStorage.getItem("bpCode");
  const lob = currentCompany?.lineOfBusiness || localStorage.getItem("lineOfBusiness");

   // Define multiple allowed FMCG customers who should see bulk transfers
  const ALLOWED_FMCG_CUSTOMERS = [
    "0010011882",  // First allowed customer
    "0010011792",  // Second allowed customer
  ];

  // Check if this is one of the allowed FMCG customers
  // eslint-disable-next-line no-unused-vars
  const isAllowedFMCGCustomer = ALLOWED_FMCG_CUSTOMERS.includes(bpCode) && lob === "02";

  // Check if this is any other FMCG customer (LOB 02 but not in allowed list)
  const isOtherFMCGCustomer = !ALLOWED_FMCG_CUSTOMERS.includes(bpCode) && lob === "02";

  const filteredRoutesConfigAdmin = routesConfigAdmin.map((group) => ({
    ...group,
    children: group.children.map((item) => {
      if (!item.children) return item;

      return {
        ...item,
        children: item.children.filter((child) => {
          // Remove transfer-in/transfer-out for STATIC contractType
          if (contractType === "STATIC" && ["transfer-in", "transfer-out"].includes(child.id)) {
            return false;
          }

          // Remove bulk transfers for non-allowed FMCG customers
          if (isOtherFMCGCustomer && ["bulk-transfer-in", "bulk-transfer-out"].includes(child.id)) {
            return false;
          }

          return true;
        }),
      };
    }),
  }));

  return filteredRoutesConfigAdmin;
}
